<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
        <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                 @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
            <el-row :gutter="15">

                                <el-form-item label="openid:">
                    <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                        <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                                            <el-form-item label="姓名:">
                    <el-input v-model="table.where.name" placeholder="请输入姓名"  clearable/>
                </el-form-item>
                                            <el-form-item label="电话:">
                    <el-input v-model="table.where.phone" placeholder="请输入电话"  clearable/>
                </el-form-item>
                                            <el-form-item label="具体地址:">
                    <el-input v-model="table.where.address" placeholder="请输入具体地址"  clearable/>
                </el-form-item>
                                            <el-form-item label="门牌号:">
                    <el-input v-model="table.where.house_num" placeholder="请输入门牌号"  clearable/>
                </el-form-item>
                                            <el-form-item label="默认地址:">
                    <el-select v-model="table.where.default" filterable placeholder="请选择">
                                                <el-option label="否" value="0"></el-option>
                                                <el-option label="是" value="1"></el-option>
                                            </el-select>
                </el-form-item>
                                            <el-form-item label="创建时间:" >
                    <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                                    end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>
                </el-form-item>
                


            <el-form-item>
                <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                           class="ele-btn-icon">查询
                </el-button>
                <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                           v-if="permission.includes('sys:useraddress:export')">导出数据
                </el-button>
            </el-form-item>
        </el-row>
    </el-form>
      <!-- 操作按钮 -->

      <div class="ele-table-tool ele-table-tool-default">
          <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                     class="ele-btn-icon" size="small" >刷新
          </el-button>
        <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:useraddress:add')">添加
        </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:useraddress:dall')">批量删除
        </el-button>
          <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                     @click="search_show=!search_show">搜索</el-button>
      </div>

      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
        <template slot-scope="{index}">
          <el-table-column type="selection" width="45" align="center" fixed="left"/>
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                        <el-table-column prop="user_id" label="openid" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                    <el-tag v-for="(item,index) in row.user_id_info" :key="index">{{item.nick_name+item.phone}}</el-tag>
                </template>
            </el-table-column>
                                <el-table-column prop="name" label="姓名" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="phone" label="电话" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="address" label="具体地址" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="house_num" label="门牌号" sortable="custom" show-overflow-tooltip min-width="120"/>

                                <el-table-column prop="default" label="默认地址" show-overflow-tooltip min-width="250" >
                <template slot-scope="{row}">
                                            <el-tag v-if="row.default == 0" :key="index">否</el-tag>
                                            <el-tag v-if="row.default == 1" :key="index">是</el-tag>
                                    </template>
            </el-table-column>

                        
          <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
            <template slot-scope="{row}">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:useraddress:edit')">修改</el-link>
              <el-popconfirm title="确定要删除此收货地址吗？" @confirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:useraddress:delete')">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id?'修改收货地址':'添加收货地址'" :visible.sync="showEdit"  width="800px" :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
        
          <el-form-item label="openid:" prop="user_id">
              <el-select v-model="editForm.user_id" filterable placeholder="请选择">
                  <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone" :value="item.id">
                  </el-option>
              </el-select>

          </el-form-item>
                          <el-form-item label="姓名:" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入姓名" clearable />
          </el-form-item>
                          <el-form-item label="电话:" prop="phone">
              <el-input v-model="editForm.phone" placeholder="请输入电话" clearable />
          </el-form-item>
                          <el-form-item label="具体地址:" prop="address">
              <el-input v-model="editForm.address" placeholder="请输入具体地址" clearable />
          </el-form-item>
                          <el-form-item label="门牌号:" prop="house_num">
              <el-input v-model="editForm.house_num" placeholder="请输入门牌号" clearable />
          </el-form-item>
                          <el-form-item label="默认地址:" prop="default">
              <el-select v-model="editForm.default" filterable placeholder="请选择默认地址">
                                        <el-option label="否" value="0"></el-option>
                                        <el-option label="是" value="1"></el-option>
                                </el-select>
          </el-form-item>

                       
      </el-form>
      <div slot="footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import { mapGetters } from "vuex";

                    
    export default {
        name: "SysUserAddress",
        components: {
                                                        },
        data() {
            return {
                                table: {
                    url: '/user/UserAddress/index',
                    where: {}                },  // 表格配置
                choose: [],  // 表格选中数据
                showEdit: false,  // 是否显示表单弹窗
                editForm: {},  // 表单数据
                editFormTemp:{},
                admin_list:[],
                user_list:[],
                search_show:false,
                                    user_openinfo_list:[],
                                editRules: {  // 表单验证规则
                                                            
                            user_id: [
                                {required: true, message: '请选择openid', trigger: 'blur'}
                                ],
                        
                                            
                            name: [
                                {required: true, message: '请输入姓名', trigger: 'blur'}],
                        
                                            
                            phone: [
                                {required: true, message: '请输入电话', trigger: 'blur'}],
                        
                                            
                            address: [
                                {required: true, message: '请输入具体地址', trigger: 'blur'}],
                        
                                            
                            house_num: [
                                {required: true, message: '请输入门牌号', trigger: 'blur'}],
                        
                                            
                            default: [
                                {required: true, message: '请选择默认地址', trigger: 'blur'}
                                ],
                        
                                            
                            create_time: [
                                {required: true, message: '请选择创建时间', trigger: 'blur'}
                                ],
                        
                                    
            },
        }
        },
        computed: {
            ...mapGetters(["permission"]),
                    },
        mounted() {

                        this.userAllList();
                                                this.UserOpeninfoAllList();                    },
        methods: {
            /**
             * 关闭
             */
            closeDialog(){
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/user/UserAddress/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({lock: true});
                        this.$http.post('/user/UserAddress/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({type: 'success', message: res.data.msg});
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) {  // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的收货地址吗?', '提示', {type: 'warning'}).then(() => {
                        const loading = this.$loading({lock: true});
                        this.$http.post('/user/UserAddress/delete', {id: ids}).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({type: 'success', message: res.data.msg});
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else {  // 单个删除
                    const loading = this.$loading({lock: true});
                    this.$http.post('/user/UserAddress/delete', {id:row.id}).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({type: 'success', message: res.data.msg});
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

                        /* 获取全部会员 */
            userAllList(){
                this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.user_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
                                    /* 导出数据Excel */
            exportExcel() {
                let ids  = this.choose.map(d => d.id)
                if(ids.length == 0){
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {id:ids})
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
                    //查询其他信息
           UserOpeninfoAllList(){
                this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.user_openinfo_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
        
        }
    }
</script>

<style scoped>
    .ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
        width: 100%;
    }
</style>